<template>
  <show-layout>

    <template slot="header">
      <v-btn icon :to="{ path: '/admin' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>
        {{ this.application.application_type.acronym }} - {{ this.application.application_type.name }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn large color="white" class="success--text" v-if="application.locked_by != null" :disabled="!(remainingBasicDocuments === 0 &&
        remainingSpecificDocuments === 0 &&
        remainingTechnicDocuments === 0 &&
        (this.application.status === 'waiting_for_review' ||
          this.application.status === 'in_review' ||
          this.application.status === 'intimated'))" @click="finishReview">
        <v-icon left>mdi-check-all</v-icon>
        <span class="text">
          Concluir análise
        </span>
      </v-btn>
      <v-btn v-else large color="white" class="success--text" @click="startAnalysis">
        <v-icon left>mdi-check-all</v-icon>
        <span class="text">
          Iniciar Análise
        </span>
      </v-btn>
    </template>

    <template slot="sidebar">
      <v-card flat class="mb-2" v-if="application.infraction && application.sended === true">
        <v-card-text>
          <span class="badge green">
            ENVIADO PARA DOCGO
          </span>
        </v-card-text>
      </v-card>
      <sidebar-show-application :application="application">
      </sidebar-show-application>
    </template>

    <template slot="content">

      <v-subheader v-if="application.intimations.length > 0" class="subheader-1">
        Intimações
      </v-subheader>

      <expansion-panel-for-documents v-for="intimation in application.intimations"
        v-if="application.intimations.length > 0" :key="intimation.id" :application="application"
        :documents="intimation.documents" :isAdmin="true" :locked="application.locked_by"
        :document-type="`Prazo: ${moment(intimation.due_date, 'YYYY-MM-DD').format('DD/MM/YYYY')}`"
        :viewedAt="intimation.viewed_at" type="intimation" category="specific">
      </expansion-panel-for-documents>

      <template v-if="application.application_type.name == 'Defesa de Auto de Infração'">
        <v-subheader class="subheader-1">
          Documentos necessários
        </v-subheader>

        <infraction-notice-document :application="application" :isAdmin="true">
        </infraction-notice-document>
      </template>

      <v-subheader v-if="application.intimations.length === 0" class="subheader-1">
        Documentos para Análise
      </v-subheader>

      <expansion-panel-for-documents v-if="basicDocuments.length > 0" :application="application"
        :documents="basicDocuments" :isAdmin="true" :locked="application.locked_by" document-type="Básico"
        category="basic">
      </expansion-panel-for-documents>

      <expansion-panel-for-documents v-if="specificDocuments.length > 0" :application="application"
        :documents="specificDocuments" :isAdmin="true" :locked="application.locked_by" document-type="Específico"
        category="specific">
      </expansion-panel-for-documents>

      <expansion-panel-for-documents v-if="technicDocuments.length > 0" :application="application"
        :documents="technicDocuments" :isAdmin="true" :locked="application.locked_by" document-type="Técnico"
        category="technic">
      </expansion-panel-for-documents>

      <admin-show-pdf-dialog />

    </template>
  </show-layout>
</template>

<script>
import ShowLayout from '@/layouts/ShowLayout';
import SidebarShowApplication from '@/components/application/show/SidebarShowApplication';
import ExpansionPanelForDocuments from '@/components/application/show/ExpansionPanelForDocuments';
import AdminShowPdfDialog from '@/components/admin/application/show/AdminShowPdfDialog';
import InfractionNoticeDocument from '@/components/application/show/InfractionNoticeDocument';
import moment from 'moment';

export default {
  name: 'AdminShowApplication',
  components: {
    ShowLayout,
    SidebarShowApplication,
    ExpansionPanelForDocuments,
    InfractionNoticeDocument,
    AdminShowPdfDialog,
  },
  created() {
    this.$store.dispatch('setLoadingDialog', true);
    this
      .$store
      .dispatch('adminFetchApplication', this.$route.params.id)
      .finally(() => {
        this.isLoading = false;
        this.$store.dispatch('setLoadingDialog', false);
      });
  },
  data() {
    return {
      moment,
    };
  },
  computed: {
    application() {
      return this.$store.getters.application;
    },
    basicDocuments() {
      return this.$store.getters.documents.filter(a => a.document_type.category === 'basic');
    },
    specificDocuments() {
      return this.$store.getters.documents.filter(a => a.document_type.category === 'specific');
    },
    technicDocuments() {
      return this.$store.getters.documents.filter(a => a.document_type.category === 'technic');
    },

    remainingBasicDocuments() {
      const documents = this.$store.getters.documents;
      return documents.reduce((prev, elem) => {
        if (elem.last_document_version !== null &&
          elem.last_document_version.status === 'awaiting_review' &&
          elem.document_type.category === 'basic') {
          return prev + 1;
        }
        return prev;
      }, 0);
    },
    remainingSpecificDocuments() {
      const documents = this.$store.getters.documents;
      return documents.reduce((prev, elem) => {
        if (elem.last_document_version !== null &&
          elem.last_document_version.status === 'awaiting_review' &&
          elem.document_type.category === 'specific') {
          return prev + 1;
        }
        return prev;
      }, 0);
    },
    remainingTechnicDocuments() {
      const documents = this.$store.getters.documents;
      return documents.reduce((prev, elem) => {
        if (elem.last_document_version !== null &&
          elem.last_document_version.status === 'awaiting_review' &&
          elem.document_type.category === 'technic') {
          return prev + 1;
        }
        return prev;
      }, 0);
    },
  },
  methods: {
    startAnalysis() {
      this.$store.dispatch('startAnalysis', this.application.id)
        .then(() => { })
        .catch((err) => {
          this.$swal({
            type: 'error',
            titleText: err.response.data.message,
          });
          this.$router.push('/admin');
        });
    },
    isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    finishReview() {
      this.$store.dispatch('setLoadingDialog', true);
      this.$store.dispatch('finishReview', this.application)
        .then(() => {
          this.$swal({
            type: 'success',
            titleText: 'Análise Finalizada!',
          });
          this.$router.push('/admin');
        })
        .catch((err) => {
          try {

            const messages = [];

            if (Array.isArray(err.response.data)) {
              for (const message of err.response.data) {

                if (this.isJsonString(message)) {

                  messages.push(...JSON.parse(message));
                } else {
                  messages.push(message)
                }

              }
            }

            this.$swal({
              type: 'error',
              title: 'Erro',
              text: messages.join('. '),
            });

          } catch (e) {
            console.log(e)
            this.$swal({
              type: 'error',
              title: 'Erro',
              text: 'Erro desconhecido.',
            });
          }
        }).finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.mt-3 {
  margin: 10px;
}

.subheader-1 {
  font-size: 12px;
  font-family: Avenir, Open Sans, Helvetica, Arial, sans-serif;
  text-transform: uppercase;
}

.subheader-2 {
  font-size: 15px;
  font-family: Avenir, Open Sans, Helvetica, Arial, sans-serif;
}

.solicitante {
  font-size: 14px;
  text-transform: capitalize;
}
</style>
